<template>
  <v-container fluid class="mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
                    <v-btn color="default" class="button-shadow mb-2 mr-0 mr-sm-2" v-on:click="PrintElement('print-page')">
                      <v-icon class="mr-2">mdi-printer</v-icon>
                      Print
                    </v-btn>
                    <v-btn color="success" class="button-shadow" to="/routeplan/list">
                      <v-icon class="mr-2">mdi-check</v-icon>
                      Done
                    </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12" id="print-page">
        <v-row class="print-page">
          <v-col cols="12" md="8" sm="12">
            <v-card class="ma-1">
              <v-card-text class="printBody">
                <v-row>&nbsp;</v-row>
                <v-row justify="space-between">
                  <table style="width: 100%; margin-right: 10px; margin-left: 10px;">
                    <tr>
                      <td style="width:40%"><img :src="logo.src" :height="logo.height"  alt="Logo" /></td>
                      <td></td>
                      <td style="width: 35%; text-align: right; vertical-align: text-top">
                         <table style="width: 100%">
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Plan Num</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.routeplannum }}</span></td>
                          </tr>
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Date</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt; text-alignment: right;">{{ new Date(initvalue.routeplandate).toLocaleString('EN-SG',{ year: 'numeric', month: 'numeric', day: 'numeric' })  }}</span></td>
                          </tr>
                         </table> 

                      </td>
                    </tr>
                    <tr>
                      <td colspan="3"><div align="center"><h4 class="ma-0">{{ initvalue.routeplantype }}</h4></div></td>
                    </tr>
                  </table>
                </v-row>
                <v-row class="mb-5 greyBold--text">
                  <table style="width: 100%; margin-right: 10px; margin-left: 10px;" cellpadding="0" cellspacing="0">
                    <tr>
                      <td style="width: 35%; vertical-align: text-top">
                        <div>
                          <span style="font-size: 11pt; font-weight: bold">Location</span>
                          <p style="margin-top: 0;margin-bottom: 0;">{{ locations.length>0 ? locations.find(location=>location._id == initvalue.locationid)['locationname'] : '' }}</p>
                          <p style="margin-top: 0;margin-bottom: 0;">{{ initvalue.routeplanname }}</p>
                        </div>
                      </td>
                      <td>&nbsp;&nbsp;</td>
                      <td style="width: 45%; text-align: right; vertical-align: text-top">
                        <table  style="width: 100%">
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Sales Rep</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt; text-alignment: right;">{{  users.length>0 ? users.find(user=>user._id == initvalue.repid)['username'] : ''  }}</span></td>
                          </tr>
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Status</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt; text-alignment: right;">{{ initvalue.routeplanstatus }}</span></td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                </v-row>
                <p style="margin-top: 0px; margin-bottom: 5px; font-size: 14pt; font-weight: bold;">Route Visits</p>
                <table style="width: 100%" cellpadding="0" cellspacing="0">
                    <thead>
                    <tr>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid">Day</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid">Area</th>
                      <th colspan="2" style="text-align: left; border-bottom: 1px; border-bottom-style: solid" width="50%">Customers List</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr style="margin-bottom: 10px;" v-for="(trans) in initvalue.areas"  v-bind:key="trans._id">
                          <td style="vertical-align: text-top; padding-bottom: 10px; border-bottom: 1px black dotted;">
                            <p style="margin-top: 0px; margin-bottom: 0px;">{{ new Date(trans.areadate).toLocaleString('EN-SG',{ year: 'numeric', month: 'numeric', day: 'numeric' })  }}</p>
                            <p style="margin-top: 0px; margin-bottom: 0px;">{{ trans.isHalfDay==true ? 'Half' : '' }}</p>
                          </td>
                          <td style="vertical-align: text-top; border-bottom: 1px black dotted;">
                            <p style="margin-top: 0px; margin-bottom: 0px;">{{ trans.areadesc }}</p>
                            <p style="margin-top: 0px; margin-bottom: 0px;">
                              {{ regions.length>0 ? regions.find(region=>region._id==trans.regionid)['regionname'] : '' }}
                              {{ townships.length>0 ? townships.find(township=>township._id==trans.townshipid)['townshipname'] : '' }}
                            </p>
                            <p v-if="trans.districtid" style="margin-top: 0px; margin-bottom: 0px;">
                              {{ districts.length>0 ? districts.find(district=>district._id==trans.districtid)['districtname'] : '' }}
                            </p>
                          </td>
                          <td style="vertical-align: text-top; border-bottom: 1px black dotted; width: 25%;">
                            <p v-for="num in Array.from({length: 6}, (value, index) => (index+1))" v-bind:key="num" style="margin-top: 0px; margin-bottom: 7px;">{{ num }}. {{ initvalue.visits.find(visit=>visit.visitnum==num && visit.daynum==trans.daynum)!=null ? initvalue.visits.find(visit=>visit.visitnum==num && visit.daynum==trans.daynum)['visitname'] : '' }}</p>
                          </td>
                          <td style="vertical-align: text-top; border-bottom: 1px black dotted; width: 25%;">
                            <p v-for="num in Array.from({length: 6}, (value, index) => (index+7))" v-bind:key="num" style="margin-top: 0px; margin-bottom: 7px;">{{ num }}. {{ initvalue.visits.find(visit=>visit.visitnum==num && visit.daynum==trans.daynum)!=null ? initvalue.visits.find(visit=>visit.visitnum==num && visit.daynum==trans.daynum)['visitname'] : '' }}</p>
                          </td>
                          
                        </tr>
                    </tbody>
                </table>
                <p style="margin-top: 0; margin-bottom: 50px">&nbsp;</p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
    import {mapActions, mapState} from "vuex";
    import { getLogo } from '../../../util/tools';

    export default {
        name: 'PrintPage',
        data(){
          return {
            initvalue: {},
            logo: null,
          };
        },
        methods: {
          ...mapActions('District', ['getDistrictsRequest']),
          ...mapActions('Item', ['getItemsRequest']),
          ...mapActions('Location', ['getLocationsRequest']),
          ...mapActions('User', ['getUsersRequest']),
          ...mapActions('Region', ['getRegionsRequest']),
          ...mapActions('Township', ['getTownshipsRequest']),
          PrintElement(divid) {
            var content = document.getElementById(divid).innerHTML;
            var mywindow = window.open('', 'Print', 'height=800,width=1000,menubar=0,location=0,status=0,titlebar=0,toolbar=0');

            mywindow.document.write('<html><head><title>Print</title>');
            mywindow.document.write('</head><body onclick="window.print();">');
            mywindow.document.write(content);
            mywindow.document.write('</body></html>');

            mywindow.document.close();
            mywindow.focus()
            mywindow.print();
            return;
          },
        },
        computed: {
          ...mapState('District', ['districts']),
          ...mapState('Item', ['items']),
          ...mapState('Location', ['locations']),
          ...mapState('Region', ['regions']),
          ...mapState('Township', ['townships']),
          ...mapState('User', ['users']),
        },
        async created () {
          this.initvalue = this.$route.params;
          this.logo = getLogo(this.initvalue.companyid); 
          if(!this.initvalue._id) this.$router.push({ name: 'RoutePlanList' });
          if(this.districts.length==0) await this.getDistrictsRequest(); 
          if(this.items.length==0) await this.getItemsRequest(); 
          if(this.locations.length==0) await this.getLocationsRequest();
          if(this.regions.length==0) await this.getRegionsRequest();
          if(this.townships.length==0) await this.getTownshipsRequest();
          if(this.users.length==0) await this.getUsersRequest(); 
            
          
        },
        mounted(){

        }
    };
</script>

<style src="./Print.scss" lang="scss" scoped />
